import {
  Component,
  booleanAttribute,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTooltip } from '@angular/material/tooltip';
import { isRequired } from '../../utilities/form-control.util';
import { Checkbox } from '../checkbox/checkbox.component';

@Component({
  selector: 'procure-input-check',
  templateUrl: './input-check.component.html',
  imports: [Checkbox, MatTooltip],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class InputCheck {
  readonly id = input<string | null>(null);
  readonly control = input.required<FormControl>();
  readonly tooltip = input<string>('');
  readonly labelPosition = input<'before' | 'after'>('after');

  readonly showMode = input<boolean, boolean | string>(false, {
    transform: booleanAttribute,
  });

  readonly condensed = input<boolean, boolean | string>(false, {
    transform: booleanAttribute,
  });

  readonly valueChange = output<MatCheckboxChange>();

  protected get isRequired(): boolean {
    return isRequired(this.control());
  }
}
